import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Form, Button, Space, Select, Row, Col,
} from 'antd';

import PageContent from '../../components/Layout/PageContent';
import HeroBannerForm from './Forms/HeroBannerForm';
import MagazineCarouselForm from './Forms/MagazineCarouselForm';
import MiniBannerForm from './Forms/MiniBannerForm';
import './MobileCards.css';

const MobileCardsForm = () => {
  const [type, setType] = useState();
  const [form] = Form.useForm();

  const handleTypeChange = (value) => {
    setType(value);
  };

  return (
    <PageContent title="Create Card" breadcrumb={['Mobile App', 'Home', 'Card New']}>
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
      >
        <Row gutter={27}>
          <Col span={12}>
            <Form.Item
              label="Card Type"
              name="type"
              rules={[{ required: true }]}
              required
            >
              <Select onChange={handleTypeChange} placeholder="- Select a Card Type -">
                <Select.Option value="heroBanner">Hero Banner</Select.Option>
                <Select.Option value="magazineCarousel">Magazine Carousel</Select.Option>
                <Select.Option value="miniBanner">Mini Banner</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {type && (
          {
            heroBanner: <HeroBannerForm />,
            magazineCarousel: <MagazineCarouselForm />,
            miniBanner: <MiniBannerForm />,
          }[type]
        )}
        <Form.Item wrapperCol={{ gutter: 16 }} style={{ marginTop: 50 }}>
          <Space>
            <Button type="primary" size="large" htmlType="submit">Publish</Button>
            <Button type="secondary" size="large">Review</Button>
            <Link to="/mobile/cards"><Button type="link" size="large">Cancel</Button></Link>
          </Space>
        </Form.Item>
      </Form>
    </PageContent>
  );
};

export default MobileCardsForm;
